// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partner-slide {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.partner-logo {\n  max-width: 100%;\n  max-height: 40px;\n  object-fit: contain;\n}\n", ""]);
// Exports
module.exports = exports;
